export default {
  nav: {
    home: "Home",
    portfolio: "Portfolio",
    whoAreWe: "Wie Zijn Wij",
    contact: "Contact",
    getInTouch: "Neem Contact Op",
  },
  footer: {
    description:
      "Belgisch ingenieursbureau gespecialiseerd in programmeren, automatisering, projectmanagement en integratie-engineering.",
    navigation: "Navigatie",
    contact: "Contact",
    location: "Antwerpen, België",
    rights: "Alle rechten voorbehouden.",
    tagline: "Met precisie ontworpen in België",
    privacy: "Privacybeleid",
  },
  privacy: {
    kicker: "Privacy",
    title: "Privacybeleid",
    intro: "Hoe TEKDAM BV omgaat met uw persoonsgegevens.",
    lastUpdated: "Laatst bijgewerkt: 11 juni 2026",
    sections: [
      {
        heading: "Wie zijn wij?",
        paragraphs: [
          "TEKDAM BV (BTW: BE1024.973.363), gevestigd in Antwerpen, België, is de verwerkingsverantwoordelijke voor de persoonsgegevens die via deze website worden verzameld. Voor vragen over dit privacybeleid kunt u ons bereiken via info@tekdam.be.",
        ],
      },
      {
        heading: "Welke gegevens verzamelen wij?",
        paragraphs: [
          "Wanneer u ons contactformulier invult, verzamelen wij de gegevens die u zelf opgeeft: uw voornaam, achternaam, e-mailadres, telefoonnummer (optioneel) en uw bericht.",
          "Daarnaast bewaart deze website uw taalvoorkeur (Nederlands of Engels) lokaal in uw browser. Deze voorkeur verlaat uw toestel niet en wordt niet met ons gedeeld.",
        ],
      },
      {
        heading: "Waarvoor gebruiken wij uw gegevens?",
        paragraphs: [
          "Wij gebruiken de gegevens uit het contactformulier uitsluitend om uw vraag te behandelen en u te antwoorden. De rechtsgrond hiervoor is uw toestemming, die u geeft door het formulier te versturen, en ons gerechtvaardigd belang om op zakelijke vragen te reageren.",
          "Wij gebruiken uw gegevens niet voor marketing en versturen geen nieuwsbrieven.",
        ],
      },
      {
        heading: "Cookies en analytics",
        paragraphs: [
          "Deze website gebruikt geen trackingcookies en geen analytics- of advertentiediensten. Er wordt enkel uw taalvoorkeur lokaal in uw browser opgeslagen om de website in uw taal te tonen.",
        ],
      },
      {
        heading: "Met wie delen wij uw gegevens?",
        paragraphs: [
          "Wij verkopen of verhuren uw gegevens nooit aan derden. Berichten uit het contactformulier worden technisch verwerkt door FormSubmit, een dienst die het formulier aflevert in onze mailbox (info@tekdam.be). Daarnaast worden uw gegevens enkel verwerkt door onze e-mailprovider.",
        ],
      },
      {
        heading: "Hoe lang bewaren wij uw gegevens?",
        paragraphs: [
          "Wij bewaren uw bericht en contactgegevens niet langer dan nodig om uw vraag te behandelen en een eventuele samenwerking op te volgen, tenzij een wettelijke verplichting een langere bewaartermijn vereist.",
        ],
      },
      {
        heading: "Uw rechten",
        paragraphs: [
          "Onder de Algemene Verordening Gegevensbescherming (AVG/GDPR) heeft u het recht op inzage, verbetering, verwijdering en overdraagbaarheid van uw persoonsgegevens, evenals het recht om de verwerking te beperken of er bezwaar tegen te maken. U kunt deze rechten uitoefenen door een e-mail te sturen naar info@tekdam.be.",
          "Bent u van mening dat wij uw gegevens onrechtmatig verwerken, dan kunt u een klacht indienen bij de Belgische Gegevensbeschermingsautoriteit (www.gegevensbeschermingsautoriteit.be).",
        ],
      },
      {
        heading: "Wijzigingen aan dit beleid",
        paragraphs: [
          "Wij kunnen dit privacybeleid van tijd tot tijd aanpassen. De meest recente versie is steeds beschikbaar op deze pagina.",
        ],
      },
    ],
  },
  home: {
    hero: {
      titleLine1: "Where Technology",
      titlePre: "Meets ",
      titleHighlight: "Engineering",
      titlePost: "",
      paragraph:
        "Belgisch ingenieursbureau gespecialiseerd in software, automatisering en systeemintegratie.",
      viewWork: "Bekijk Ons Werk",
      contactUs: "Contacteer Ons",
    },
    services: {
      kicker: "Wat We Doen",
      title: "Onze Kernexpertise",
      items: [
        {
          title: "Programmeren",
          description:
            "Full-stack softwareontwikkeling, van webapplicaties en API's tot embedded systemen en industriële automatiseringssoftware.",
        },
        {
          title: "Projectengineering",
          description:
            "End-to-end projectmanagement voor complexe engineeringprojecten, van concept en ontwerp tot validatie en oplevering.",
        },
        {
          title: "Automatisering",
          description:
            "Industriële automatiseringsoplossingen zoals PLC-programmatie, SCADA-systemen en smart manufacturing voor Industry 4.0 en 5.0.",
        },
        {
          title: "Integratie",
          description:
            "Naadloze integratie tussen legacy- en moderne systemen. Verbinden van databanken, PLC's, SCADA, IoT en webapplicaties.",
        },
      ],
    },
    stats: [
      { value: "10+", label: "Systemen Geïntegreerd" },
      { value: "20+", label: "Technologieën Beheerst" },
      { value: "100%", label: "Klanttevredenheid" },
      { value: "5+", label: "Jaar Ervaring" },
    ],
    industries: {
      kicker: "Sectoren",
      title: "De Brug Tussen Legacy & Innovatie",
      paragraph:
        "Van farmaceutische productielijnen uit de jaren '90 tot geavanceerde Industry 5.0 IoT-platformen: wij verbinden systemen over generaties heen. Onze expertise omvat decennia aan industriële technologische evolutie.",
      items: [
        { title: "Farmaceutica", description: "GMP-conforme systemen, industriele applicaties, automatisatie & validatie." },
        { title: "Financiële Diensten", description: "Webapplicaties op maat voor CRM, dossierbeheer en klantenbeheer. Geautomiseerde flows." },
        { title: "Industriële IoT", description: "Sensornetwerken, Modbus TCP, MQTT en realtime dataplatformen." },
        { title: "Legacy-integratie", description: "Oudere systemen integreren met moderne applicaties en tools." },
      ],
      technologies: [
        ".NET / C#",
        "IoT / MQTT",
        "Modbus TCP",
        "PLC / SCADA",
        "Webapplicaties",
        "Industry 5.0",
        "Vue.js",
        "AI Agents",
      ],
    },
    cta: {
      title: "Klaar om uw project te starten?",
      paragraph:
        "Laten we bespreken hoe TEKDAM Engineering precisie, betrouwbaarheid en innovatie kan brengen in uw volgende project.",
      button: "Neem Contact Op",
    },
  },
  about: {
    kicker: "Over Ons",
    title: "Wie Zijn Wij?",
    intro:
      "Een Belgisch ingenieursbureau gedreven door precisie, innovatie en een niet-aflatende zoektocht naar technische excellentie.",
    mission: {
      kicker: "Onze Missie",
      title: "Engineeringoplossingen Die Blijven Werken",
      paragraphs: [
        "TEKDAM Engineering is een Belgisch ingenieurs- en technologiebedrijf met hoofdzetel in Kontich, nabij Antwerpen. Wij zijn gespecialiseerd in robuuste, schaalbare technische oplossingen voor sectoren waar betrouwbaarheid geen optie is, maar een vereiste.",
        "Onze expertise bestrijkt het volledige engineeringspectrum: van hands-on PLC-programmatie en SCADA-ontwerp tot moderne webapplicatieontwikkeling en complexe systeemintegratie. Wij slaan de brug tussen legacy-industriesystemen en de nieuwste technologieën.",
        "Of het nu gaat om een productielijn uit de jaren '90 koppelen aan een modern IoT-platform, een CRM op maat bouwen voor een financiële dienstverlener, of GMP-conforme monitoringsystemen ontwerpen voor farmaceutische omgevingen - wij leveren oplossingen die werken, vandaag en morgen.",
      ],
    },
    values: [
      {
        title: "Precisie",
        description: "Elk detail telt. Wij ontwikkelen oplossingen met nauwgezette aandacht voor kwaliteit en nauwkeurigheid.",
      },
      {
        title: "Innovatie",
        description: "Wij omarmen nieuwe technologieën met respect voor beproefde methodes die hun waarde hebben bewezen.",
      },
      {
        title: "Betrouwbaarheid",
        description: "Onze systemen draaien 24/7 in bedrijfskritische omgevingen, van cleanrooms tot productievloeren.",
      },
      {
        title: "Partnerschap",
        description:
          "Wij werken samen met onze klanten als echte partners en begrijpen hun business voor we ook maar één regel code schrijven.",
      },
    ],
    capabilities: {
      kicker: "Capaciteiten",
      title: "Wat Ons Onderscheidt",
      skills: [
        {
          title: "Full-Stack Ontwikkeling",
          description:
            "Moderne webapplicaties met Vue.js, TypeScript, .NET/C# en SQL Server. Van concept tot deployment, inclusief Docker en CI/CD-pipelines.",
        },
        {
          title: "Industriële Automatisering",
          description:
            "PLC-programmatie, SCADA-ontwerp en integratie met productielijnen. Ervaring met systemen uit drie decennia industriële technologie.",
        },
        {
          title: "IoT & Industry 5.0",
          description:
            "Sensornetwerken, Modbus TCP, MQTT-messaging en realtime dataplatformen die de fysieke wereld verbinden met intelligente software.",
        },
        {
          title: "Systeemintegratie",
          description:
            "Legacy-systemen uit de jaren '90 verbinden met moderne platformen. Protocolvertaling, datakoppeling en uniforme dashboards.",
        },
        {
          title: "Farma & Compliance",
          description:
            "GMP-documentatie, IQ/OQ/PQ-validatie en compliance-klare oplossingen voor cleanrooms van Grade A, B en C.",
        },
        {
          title: "Projectmanagement",
          description:
            "End-to-end projectengineering, van requirementsanalyse en systeemontwerp tot testen, validatie en oplevering.",
        },
      ],
    },
    approach: {
      kicker: "Onze Aanpak",
      title: "Hoe Wij Werken",
      steps: [
        {
          title: "Begrijpen",
          description: "Wij verdiepen ons in uw business, processen en technische omgeving voor we oplossingen voorstellen.",
        },
        {
          title: "Ontwerpen",
          description: "Architectuur en systeemontwerp dat rekening houdt met de huidige noden en toekomstige groei.",
        },
        {
          title: "Bouwen",
          description: "Precieze engineering met grondige tests en validatie bij elke stap.",
        },
        {
          title: "Opleveren",
          description: "Deployment, documentatie, opleiding en blijvende ondersteuning voor duurzaam succes.",
        },
      ],
    },
    cta: {
      title: "Laten We Samen Iets Groots Bouwen",
      paragraph: "Wij staan altijd open voor nieuwe projecten, uitdagingen en partnerschappen.",
      contact: "Contacteer Ons",
      work: "Bekijk Ons Werk",
    },
  },
  portfolio: {
    banner: {
      title: "Laten We Samen Iets Groots Bouwen",
      paragraph: "Wij staan altijd open voor nieuwe projecten, uitdagingen en partnerschappen.",
      contact: "Contacteer Ons",
      about: "Wie Zijn Wij",
    },
    kicker: "Ons Werk",
    title: "Geselecteerde Projecten",
    intro: "Een zorgvuldige selectie van engineeringprojecten in de farmaceutische productie en financiële technologie - van productielijnmonitoring tot platformen op maat.",
    landing: {
      scroll: "Scroll",
      enter: "Ontdek",
    },
    industries: {
      pharma: {
        eyebrow: "Life Sciences",
        name: "Farmaceutische Industrie",
        tagline: "IT- & automatiseringsconsultancy voor pharma",
        description:
          "Wij helpen farmaceutische producenten bij het ontwerpen, bouwen en valideren van de software-, automatiserings- en monitoringsystemen die hun productie aansturen - een brug tussen IT, OT en GMP-compliance.",
        explore: "Ontdek farmaceutisch werk",
        stats: [
          { value: "20+", label: "Geïntegreerde Systemen" },
          { value: "2", label: "Site-brede Monitoringsystemen" },
        ],
      },
      fintech: {
        eyebrow: "Financiële Diensten",
        name: "Financiële Technologie",
        tagline: "Platformen op maat voor financiële diensten",
        description:
          "Van een gepersonaliseerd CRM dat een volledig kredietbedrijf draaiend houdt tot een gekoppelde klantenwebsite - wij bouwen veilige fintech-platformen op maat waar mensen dagelijks op vertrouwen.",
        explore: "Ontdek financieel werk",
        stats: [
          { value: "2", label: "Platformen" },
        ],
      },
    },
    category: {
      back: "Terug naar sectoren",
      projectsTitle: "Geselecteerd Werk",
      projectsIntro: "Projecten gerealiseerd in deze sector. Selecteer er een voor de details.",
    },
    capabilities: {
      title: "Bijkomende Expertise",
      intro: "Meer engineeringdiensten die wij leveren binnen farmaceutische projecten.",
    },
    filters: {
      all: "Alle",
      pharma: "Farmaceutisch",
      fintech: "Financiële Tech",
    },
    categories: {
      pharma: "Farmaceutisch",
      fintech: "Financiële Technologie",
    },
    viewProject: "Bekijk project",
    projects: [
      {
        slug: "production-line-monitoring",
        title: "Productielijn Grade A Monitoring",
        summary: "Eén Grade A-monitoringlaag die PLC's, SCADA, databanken en webapplicaties verbindt over productielijnen gebouwd tussen 1990 en 2026.",
        overview:
          "Een uitgebreid monitoringsysteem op productielijnniveau dat communiceert met databanken, PLC's, SCADA-systemen en webapplicaties - operatoren en kwaliteitsteams krijgen één realtime beeld van de volledige productievloer.",
        challenge:
          "Productielijnen die over drie decennia werden geïnstalleerd spraken elk hun eigen taal: legacy-PLC's uit de jaren '90 naast moderne controllers, verschillende databanken en geïsoleerde SCADA-eilanden. Een uniform, realtime beeld ontbrak.",
        solution:
          "We bouwden een centrale monitoringlaag die met elk systeem natief communiceert - oud en nieuw - de data normaliseert en presenteert via een heldere webapplicatie. Events, alarmen en batchdata stromen naar databanken voor traceerbaarheid en rapportering.",
        highlights: [
          "Eén realtime beeld over alle productielijnen",
          "Natieve communicatie met legacy- & moderne PLC's",
          "Integratie met SCADA en databanken",
          "Volledige batchtraceerbaarheid en rapportering",
        ],
      },
      {
        slug: "environmental-monitoring",
        title: "Site-brede Omgevingsmonitoring",
        summary: "Een Industry 5.0 IoT-platform dat data van 10.000+ sensoren over de volledige site naar één centrale webapplicatie streamt, bedrijfsbreed gebruikt.",
        overview:
          "Een Industry 5.0 omgevingsmonitoringplatform dat meer dan 10.000 sensoren verbindt met een centrale webapplicatie. Realtime data ondersteunt compliance, kwaliteitsborging en operationele excellentie binnen de hele organisatie.",
        challenge:
          "Een volledige site monitoren betekent data van tienduizenden sensoren betrouwbaar verwerken, presenteren aan zeer uiteenlopende stakeholders - van operatoren tot QA tot management - en alles auditeerbaar houden voor compliance.",
        solution:
          "We bouwden een schaalbare IoT-datapijplijn en een rolbewuste webapplicatie. Sensordata wordt op grote schaal verzameld, gevalideerd en opgeslagen, met live dashboards, alerting en historische analyse op maat van elk type gebruiker.",
        highlights: [
          "10.000+ verbonden sensoren",
          "Realtime dashboards & alerting",
          "Rolgebaseerde weergaven voor elke stakeholder",
          "Compliance-klare datahistoriek",
        ],
      },
      {
        slug: "fiber-sensor-integration",
        title: "Sensor- & Glasvezelintegratie",
        summary: "Modbus TCP-servers uit glasvezelsensornetwerken uitlezen en vertalen naar MQTT-berichten voor moderne webapplicaties.",
        overview:
          "Glasvezelsensorsystemen die Modbus TCP-servers uitlezen, industriële protocollen vertalen naar MQTT-berichten en de data doorsturen naar moderne webapplicaties voor realtime monitoring en analyse.",
        challenge:
          "Industriële glasvezelsensoren bieden hun data aan via Modbus TCP - een protocol dat niet past in moderne, event-gedreven webarchitecturen. De data moest realtime de webapplicaties bereiken zonder het netwerk te overbelasten.",
        solution:
          "We ontwikkelden een protocolbrug die de Modbus TCP-servers uitleest, de metingen transformeert en herpubliceert als lichte MQTT-berichten. Webapplicaties abonneren zich en updaten onmiddellijk zodra nieuwe data binnenkomt.",
        highlights: [
          "Protocolbrug van Modbus TCP naar MQTT",
          "Realtime, event-gedreven datastroom",
          "Licht en netwerkefficiënt",
          "Direct koppelbaar aan webapplicaties",
        ],
      },
      {
        slug: "gmp-validation",
        title: "GMP-documentatie & Validatie",
        summary: "Volledige GMP-documentatie, validatieprotocollen en IQ/OQ/PQ-testing voor gereguleerde farmaceutische omgevingen.",
        overview:
          "Volledige farmaceutische GMP-documentatiediensten - validatieprotocollen, testscripts, IQ/OQ/PQ-documentatie en compliance-rapportering - voor systemen in gereguleerde omgevingen.",
        challenge:
          "In de gereguleerde farma zijn software en apparatuur slechts zo goed als hun documentatie. Elk systeem heeft gevalideerd, auditeerbaar bewijs nodig dat het exact doet wat het moet, onder GMP-toezicht.",
        solution:
          "We leveren de volledige validatielevenscyclus: het schrijven van protocollen, het uitvoeren van IQ/OQ/PQ-testscripts en het opstellen van compliance-documentatie die audits en inspecties doorstaat.",
        highlights: [
          "Validatieprotocollen & testscripts",
          "IQ / OQ / PQ-uitvoering",
          "Audit- en inspectieklare documentatie",
          "Volledige GMP-compliance-rapportering",
        ],
      },
      {
        slug: "electrical-engineering",
        title: "Elektrotechniek",
        summary: "Elektrische tekeningen en schema's voor industriële installaties, conform farmaceutische normen.",
        overview:
          "Elektrische tekeningen en schema's voor industriële installaties - ontworpen conform farmaceutische normen en naadloos geïntegreerd met automatiserings- en monitoringsystemen.",
        challenge:
          "Industriële installaties in de farma vereisen precieze, normconforme elektrische documentatie die naadloos aansluit op de automatiseringssystemen die ze aansturen.",
        solution:
          "We maken accurate elektrische tekeningen en schema's die voldoen aan de geldende normen en aansluiten op de automatiseringsarchitectuur, zodat installatie en integratie vlot verlopen.",
        highlights: [
          "Normconforme elektrische tekeningen",
          "Gedetailleerde schema's voor installaties",
          "Afgestemd op automatiseringssystemen",
          "Klaar voor integratie & oplevering",
        ],
      },
      {
        slug: "cleanroom-applications",
        title: "Cleanroomtoepassingen",
        summary: "Industriële toepassingen voor cleanrooms van Grade A, B en C en steriele productie.",
        overview:
          "Industriële toepassingen specifiek ontworpen voor cleanrooms van Grade A, B en C - conform de strengste farmaceutische productie-eisen voor steriele en gecontroleerde zones.",
        challenge:
          "Steriele en gecontroleerde productiezones stellen de hoogste eisen aan elke toepassing die erin draait. Niets mag de integriteit van een Grade A-, B- of C-omgeving in gevaar brengen.",
        solution:
          "We ontwerpen toepassingen die de cleanroomvereisten van begin tot eind respecteren - gebouwd en gedocumenteerd om te voldoen aan de eisen van steriele, gecontroleerde productie.",
        highlights: [
          "Ontworpen voor Grade A / B / C-zones",
          "Conform steriele productie-eisen",
          "Gebouwd voor gecontroleerde omgevingen",
          "Geïntegreerd met monitoring & automatisering",
        ],
      },
      {
        slug: "haspro",
        title: "HasPro - CRM-platform",
        summary: "Een gepersonaliseerd CRM- en beheersplatform dat de ruggengraat vormt van een Belgisch kredietbedrijf, actief sinds 1995.",
        overview:
          "Een gepersonaliseerde webapplicatie die de operationele ruggengraat vormt van een Belgisch kredietbedrijf. HasPro beheert contacten, documenten, nieuws, audit trails en dossiers voor woonkredieten, consumentenkredieten en verzekeringen - dagelijks gebruikt door de zaakvoerder, medewerkers en partners.",
        challenge:
          "Een kredietbedrijf, actief sinds 1995, was generieke tools ontgroeid. Ze hadden één systeem op maat nodig om klanten, documenten en dossiers te beheren - met de audit trails en compliance die een financieel bedrijf vereist.",
        solution:
          "We ontwierpen en bouwden HasPro van de grond af: een CRM op maat waar contacten, documenten, dossiers en communicatie samenkomen, met rolgebaseerde toegang voor zaakvoerder, medewerkers en partners en volledige audit-logging.",
        highlights: [
          "Contact- en klantenbeheer",
          "Documentbeheersysteem",
          "Nieuwsartikelen & communicatie",
          "Audit trail & compliance-logging",
          "Dossierbeheer (WK, LOA, Verzekeringen)",
          "Multi-user: zaakvoerder, medewerkers & partners",
        ],
      },
      {
        slug: "haspro-client-website",
        title: "HasWeb - Klantenwebsite",
        summary: "Een moderne, meertalige klantenwebsite die rechtstreeks gekoppeld is aan het interne HasPro-platform.",
        overview:
          "Een moderne, designgerichte website voor de klanten van het kredietbedrijf. Volledig gekoppeld aan het interne HasPro-platform vormt ze de brug tussen klanten en de interne werking - met leningsimulatoren, contactformulieren en meertalige ondersteuning.",
        challenge:
          "Het bedrijf wilde een verzorgde publieke uitstraling die meer was dan een brochure - ze moest echte klanten koppelen aan het interne HasPro-systeem en hen moeiteloos leningen laten simuleren en contact opnemen.",
        solution:
          "We bouwden een snelle, responsieve, meertalige website gekoppeld aan HasPro. Bezoekers kunnen leningen simuleren en aanvragen indienen die rechtstreeks in het interne systeem terechtkomen, alles opgevolgd met privacyvriendelijke analytics.",
        highlights: [
          "Modern responsief design",
          "Gekoppeld aan het interne HasPro-systeem",
          "Meertalig (NL, FR, EN, TR)",
          "Leningsimulatoren & rekentools",
          "Contactformulieren met directe routering",
          "Privacyvriendelijke analytics",
        ],
      },
    ],
    detail: {
      back: "Terug naar portfolio",
      overview: "Overzicht",
      challenge: "De Uitdaging",
      solution: "Onze Oplossing",
      highlights: "Hoogtepunten",
      tech: "Technologieën",
      notFound: "Project niet gevonden.",
      other: "Ontdek meer projecten",
      cta: {
        title: "Interesse in een vergelijkbare oplossing?",
        paragraph: "Laten we bespreken hoe we dezelfde engineering-precisie naar uw project brengen.",
        button: "Neem Contact Op",
      },
    },
    cta: {
      title: "Heeft u een project in gedachten?",
      paragraph:
        "Of u nu monitoringsystemen, webapplicaties op maat of complexe systeemintegratie nodig heeft, wij staan klaar om te helpen.",
      button: "Start een Gesprek",
    },
  },
  contact: {
    kicker: "Neem Contact Op",
    title: "Contact",
    intro: "Klaar om uw volgende project te bespreken? We horen graag van u.",
    form: {
      heading: "Stuur Ons een Bericht",
      firstName: "Voornaam",
      firstNamePlaceholder: "Jan",
      lastName: "Achternaam",
      lastNamePlaceholder: "Peeters",
      email: "E-mail",
      emailPlaceholder: "jan@voorbeeld.be",
      phone: "Telefoon",
      phonePlaceholder: "+32 ...",
      message: "Bericht",
      messagePlaceholder: "Vertel ons over uw project...",
      success: "Bedankt! We hebben uw bericht ontvangen en nemen snel contact met u op.",
      error: "Er ging iets mis. Probeer het opnieuw of mail ons rechtstreeks.",
      send: "Verstuur Bericht",
      sending: "Versturen...",
    },
    details: {
      heading: "Bedrijfsgegevens",
      location: "Antwerpen, België",
    },
    next: {
      heading: "Wat Gebeurt Er Daarna?",
      steps: [
        "We bekijken uw bericht en brengen uw noden in kaart.",
        "We plannen een gesprek om uw project in detail te bespreken.",
        "We bezorgen u een voorstel op maat met een projectroadmap.",
      ],
    },
  },
};
